import { useEffect, useState } from 'react';
import Styles from "../styles.module.scss";
import AuthHead from "../AuthHead";
import AuthMedia from '../authMedia';
import Button from '../../../components/button';
import Headline4 from '../../../components/headings/Headline4';
import GIcon from '../../../assets/images/g-icon.svg';
import { Auth } from "aws-amplify"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { CognitoHostedUIIdentityProvider  } from "@aws-amplify/auth";
import mixpanelData, { viewedpageMixpanel } from '../../../utils/mixpanel';
import { LoginForm } from './loginForm';

function Login() {

  let navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string>('')
  let query: any = window.location.href
  let urlParams: any = new URL(query);
  let provider: any = urlParams.searchParams.get('provider')  

   useEffect(() => {
    if(location.state)
    {
      console.log('location', location);      
      setError('The user is not authenticated');
    }

   },[location]);

   useEffect(() => {
    viewedpageMixpanel();
    if(provider === 'google'){
      displayUserDetails()  
    }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   },[]);

   async function displayUserDetails() { 
    Auth.userAttributes(await getCurrentUser())
    .then(async result => {
      
       let emailindex = result.findIndex((item) => item.Name === 'email');
       let loginidindex = result.findIndex((item) => item.Name === 'sub');
       let given_name_index = result.findIndex((item) => item.Name === 'given_name');
       let family_name_index = result.findIndex((item) => item.Name === 'family_name');
       let roleId = result.findIndex((item) => item.Name === 'custom:roleid');
      localStorage.setItem('Name', result[given_name_index].Value + ' ' + result[family_name_index].Value)
      localStorage.setItem('loginId', result[loginidindex].Value)
      localStorage.setItem('Email', result[emailindex].Value) 
      if(roleId > -1){
        localStorage.setItem('Role', result[roleId].Value)
       }else{
        localStorage.setItem('Role', 'RECRUITER')
       }

       const session = await Auth.currentSession();
       const accessToken = session.getIdToken().getJwtToken();   
       const refreshToken = session.getRefreshToken().getToken();
       localStorage.setItem('Token', accessToken)
       localStorage.setItem('refreshToken', refreshToken)

      //  await getToken()
      //  console.log('token', token1);
       
      if (accessToken && (roleId < 0 || result[roleId].Value === 'RECRUITER')){
        navigate('/dashboard')
        mixpanelData('TG - Login Successfully1', {
          'Source': 'Recruiter successfully logged in to the system',
          'Recruiter name': result[given_name_index].Value + ' ' + result[family_name_index].Value,
          'Recruiter email': result[emailindex].Value,
          'distinct_id': result[emailindex].Value,
          'Recruiter id': result[loginidindex].Value
        })
        mixpanelData('New TG - Recruiter Login', {
          'Source': 'Recruiter successfully logged in to the system',
          'Recruiter name': result[given_name_index].Value + ' ' + result[family_name_index].Value,
          'Recruiter email': result[emailindex].Value,
          'distinct_id': result[emailindex].Value,
        })
      } 
      else if(result[roleId].Value === 'CS-RECRUITER'){
        navigate('/CRpositions')
        mixpanelData('New TG - CSR-Login', {
          'source': 'CS-Recruiter successfully logged in to the system',
          'Recruiter name': result[given_name_index].Value + ' ' + result[family_name_index].Value,
          'Recruiter email': result[emailindex].Value,
          'distinct_id': result[emailindex].Value,
          'Recruiter id': result[loginidindex].Value
        })
      }else {
        console.log('error');
        
      }
      })
      }

      async function getCurrentUser() {
        try {
          var currentUser = await Auth.currentAuthenticatedUser()

        
          return currentUser;
        }
        catch (err: any) {
          setError(err)
        }
      } 

      const googleSignIn = () => {
    
        Auth.federatedSignIn({provider:  CognitoHostedUIIdentityProvider.Google})
        .then(result => {
         // debugger;
         // displayUserDetails()
        })
        .catch((err: any) => {
          setError(err)
        });
        }

        const submitValues = (values: any) => {
          Auth.signIn(values.email, values.password).then((async (result: any) => {
            if(result){
              // console.log('result', result);
              // let emailindex = result && result.findIndex((item: any) => item.Name === 'email');
              // let loginidindex = result.findIndex((item: any) => item.Name === 'sub');
              // let given_name_index = result.findIndex((item: any) => item.Name === 'given_name');
              // let family_name_index = result.findIndex((item: any) => item.Name === 'family_name');
              // let roleId = result.findIndex((item: any) => item.Name === 'custom:roleid');
              // console.log('hi', result.findIndex((item: any) => item.Name === 'custom:roleid'));
              
              localStorage.setItem('loginId', result.username)
              localStorage.setItem('Name', result.attributes.given_name + ' ' + result.attributes.family_name)
              localStorage.setItem('Email', result.attributes.email) 
              localStorage.setItem('Role', 'CS-RECRUITER')
              // getToken();
              navigate('/CRpositions')
            }
          }))
        }

  return (
    <section className="App">
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          <AuthHead />
          <div className={Styles.alignCenter}>
          <aside className={Styles.loginSignupWapper}>
            <Headline4>Welcome to techgenie!</Headline4>
              {/* <Button  onClick={googleSignIn} variant="socialprimary" size="medium"><img src={GIcon} alt="Gicon" />Sign in with Google</Button>
              <div className={Styles.or}>OR</div> */}
              <p className={Styles.subtext}>Your journey to find a top notch company starts here...</p>
              <div className={Styles.loginWith}>
              <Button onClick={googleSignIn} variant="socialprimary" size="medium"><img src={GIcon} alt="Gicon" />Sign in with Google</Button>

                  {/* <LoginForm emailValue={''} ClickHandler={submitValues} /> */}
              {error&&<div><p className="error-message">{error}</p></div> }      
                {/* <div className={Styles.alreadyRegistered}>Don’t have an ellow account? <Link to="/signup">Sign up</Link></div> */}
           </div>
           </aside>
          </div>
         </div>
        <AuthMedia/>
         </div>
     </section>
    );
 }
export default Login;
